import * as yup from "yup";
import {
  emailValidation,
  passwordValidationSchema,
  TransFunc,
} from "../../utils/validation";
import { ObjectSchema } from "yup";

export type LoginFormValues = {
  email: string;
  password: string;
};

export const useValidation = (tValidation: TransFunc) => {
  return yup.object<ObjectSchema<LoginFormValues>>().shape({
    email: emailValidation(tValidation),
    password: passwordValidationSchema(tValidation),
  });
};
